import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons/storage';
import {
  CONFIG_SESSION,
  NEW_FILTER_MOTORISTA_CADASTRO,
  NEW_FILTER_MOTORISTA_CADASTRO_PENDING,
  NEW_FILTER_MOTORISTA_CADASTRO_SUCCESS,
  NEW_FILTER_MOTORISTA_CADASTRO_FAILURE,
} from '@handler';
import { filterMotoristaCadastro } from '../service';
import {
  CONST_FILTER_MOTORISTA_CADASTRO,
  CONST_ROWS_PER_PAGE,
} from '@commons/consts';

function* sagaNewFilterMotoristaCadastro(action) {
  try {
    yield put({ type: NEW_FILTER_MOTORISTA_CADASTRO_PENDING });
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada
      .id;

    let where = '';
    let filterSaved =
      sessionStorage.getItem(CONST_FILTER_MOTORISTA_CADASTRO) !== null
        ? JSON.parse(sessionStorage.getItem(CONST_FILTER_MOTORISTA_CADASTRO))
        : null;
    let newFilter = {
      status: 'S',
      cpf: '',
      nome: '',
      rows:  filterSaved?.rows || CONST_ROWS_PER_PAGE,
      page: filterSaved?.page || 0,
      where: '',
    };

    if (filterSaved === null || filterSaved === undefined) {
      newFilter = {
        ...newFilter,
      };
    } else {
      if (action.newFilter) {
        newFilter.page = 0;

        if (action.args.status !== null) {
          where += `&status=${action.args.status === 'S' ? true : false}`;
        }
        if (action.args.nome !== null && action.args.nome !== '') {
          where += `&nome=${action.args.nome}`;
        }

        if (action.args.cpf) {
          where += `&cpf=${action.args.cpf}`;
        }

        newFilter = {
          ...newFilter,
          ...action.args,
          where: where,
        };
      } else {
        if (filterSaved.status !== null) {
          where += `&status=${filterSaved.status === 'S' ? true : false}`;
        }

        if (filterSaved.nome !== null && filterSaved.nome !== '') {
          where += `&nome=${filterSaved.nome}`;
        }

        if (filterSaved.cpf) {
          where += `&cpf=${filterSaved.cpf}`;
        }

        newFilter = {
          ...filterSaved,
          where: where,
        };
      }
    }

    const list = yield call(
      filterMotoristaCadastro,
      idFazenda,
      `&page=${newFilter.page}&size=${newFilter.rows}${where}`,
    );
    sessionStorage.setItem(
      CONST_FILTER_MOTORISTA_CADASTRO,
      JSON.stringify(newFilter),
    );

    yield put({
      type: NEW_FILTER_MOTORISTA_CADASTRO_SUCCESS,
      list: list,
      filter: newFilter,
    });
  } catch (_) {
    yield put({ type: NEW_FILTER_MOTORISTA_CADASTRO_FAILURE });
  }
}

export default function* watchNewFilterMotoristaCadastro() {
  yield takeLatest(
    NEW_FILTER_MOTORISTA_CADASTRO,
    sagaNewFilterMotoristaCadastro,
  );
}
